module.exports = __webpack_public_path__ + "static/media/firmaEmail.3d07bc44.svg";